import React, { useState, useEffect, useMemo } from "react"
import "./signature-profiles-details.css"
import { RadioButton } from "@progress/kendo-react-inputs"
import { PlusBlue } from "../../../assets/logos/icons"

import {
  PromotionalFooterPure,
  DialogTemplatePure,
  HeaderHLPure,
  InputHLPure,
  CheckBoxHLPure,
  TextAreaHLPure,
  ButtonHLPure,
  DialogSystemGLPure,
  ClassificationPanelPure
} from "../../pures"
import { useMediaQuery } from "@material-ui/core"
import { DividerSubtitle } from "../../pures"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { SignatureProfileService, CompanyService, CategoryService } from "../../../services"
import { NIL, NIL as NIL_UUID } from 'uuid'

export default function SignatureProfilesDetailsView({
  token,
  id,
  icons,
  profile,
  userDocumentProfiles = []
}) {
  const url = process.env.REACT_APP_MIFIRMA_API;
  const signatureProfileService = new SignatureProfileService(url);
  const companyService = new CompanyService(url);
  const categoryService = new CategoryService(url);
  const ENV = process.env

  // const applicationIconsService = new ApplicationIconsService(url)

  const history = useHistory();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [textError, setTextError] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogIcon, setShowDialogIcon] = useState(false);
  const toggleDialog = () => setShowDialog(!showDialog);
  const toggleDialogIcon = () => setShowDialogIcon(!showDialogIcon);

  const [name, setName] = useState(profile?.name || "");
  const [description, setDescription] = useState(profile?.description || "");
  const [requestName, setRequestName] = useState(profile?.defaultName || "");
  // const [resume, setResume] = useState(profile?.defaultDescription || "");
  const [comments, setComments] = useState(profile?.defaultComments || "");
  const [image, setImage] = useState(profile?.icon || null);
  const [processRandom, setprocessRandom] = useState(
    profile?.processRandom || false
  );
  const [processSequential, setprocessSequential] = useState(
    profile?.processSequential || false
  );
  const [processAprovation, setprocessAprovation] = useState(
    profile?.processAprovation || false
  );
  const [processAprovationSequential, setprocessAprovationSequential] =
    useState(profile?.processAprovationSequential || false);
  const [serviceConservationMessage, setserviceConservationMessage] = useState(
    profile?.serviceConservationMessage || false
  );
  const [serviceTimeStamp, setserviceTimeStamp] = useState(
    profile?.serviceTimeStamp || false
  );
  const [signatureTypeESign, setsignatureTypeESign] = useState(
    profile?.signatureTypeESign || false
  );
  const [signatureTypeAdvance, setsignatureTypeAdvance] = useState(
    profile?.signatureTypeAdvance || false
  );
  const [signatureTypeAutograph, setsignatureTypeAutograph] = useState(
    profile?.signatureTypeAutograph || false
  );
  const [documentProfile, setDocumentProfile] = useState({
    documentProfile: userDocumentProfiles,
  });

  const [days, setDays] = useState(profile?.numberDaysLimit || 0);
  const [uploadImage, setuploadImage] = useState(null);
  const [showBtnSave, setShowBtnSave] = useState(true)
  const [proofOfLifeChecked, setProofOfLifeChecked] = useState(profile?.proofOfLife || false)
  const [biometricId, setBiometricId] = useState('')
  const [pscSelected, setPSCSelected] = useState((profile?.serviceConservationMessage || profile?.serviceTimeStamp) ? (profile?.serviceConservationMessage) ? t("signatureProfilesDetailsView.messagePreservation") : t("signatureProfilesDetailsView.digitalTime") : '')
  const [companies, setCompanies] = useState([{ companyName: t("signatureProfilesDetailsView.digitalVault.withoutAssign"), id: NIL_UUID }])
  const [categories, setCategories] = useState([{ id: 0, name: t("signatureProfilesDetailsView.digitalVault.withoutAssign") }])
  const [subCategories, setSubCategories] = useState([])

  const [typeDocuments, setTypeDocuments] = useState([])
  const [allTypeDocuments, setAllTypeDocuments] = useState([])

  const [companyId, setCompanyId] = useState(NIL_UUID)
  const [categoryId, setCategoryId] = useState(0)
  const [typeDocument, setTypeDocument] = useState('')
  const [select, setSelect] = useState([""]);
  const [showErrorCompany, setShowErrorCompany] = useState(false)
  const [showErrorCategories, setShowErrorCategories] = useState(false)
  const [showErrorSub, setShowErrorSub] = useState(false)
  const [showErrorTypeDoc, setShowTypeDoc] = useState(false)
  const [expand, setExpand] = useState({
    ids: [],
    idField: "subcategory.id",
  });
  const [showCategoryDialog, setShowCategoryDialog] = useState(false)
  const [categoryNameError, setCategoryNameError] = useState(false)
  const [expandedNodes, setExpandedNodes] = useState([])
  const [categoryName, setCategoryName] = useState('')
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(0)
  const [permission, setPermission] = useState({})


  const isMobile = useMediaQuery("(max-width: 880px)")

  const treeViewRef = React.useRef(null)

  const canCreateSubcategory = useMemo(() => {
    if (!permission || !permission.subcategory) {
      return false
    }

    return permission.subcategory.create === true
  }, [permission])

  const currentInfoType = useMemo(() => {
    const profileDocumentsSelected = documentProfile.documentProfile.filter(item => item.checked)

    if (proofOfLifeChecked || serviceConservationMessage || profileDocumentsSelected.length > 1) {
      return 2
    }

    return 1
  }, [serviceConservationMessage, proofOfLifeChecked, documentProfile.documentProfile])

  useEffect(() => {
    getCompanies()
    getTypeDocuments()
  }, [])

  useEffect(() => {
    if (!profile || !profile.classifierCategory || !profile.classifierCategory.typeDocumentId || allTypeDocuments.length === 0) return
    let typeDocument = allTypeDocuments.find(type => type.id === profile.classifierCategory.typeDocumentId)

    if (typeDocument) {
      setTypeDocument(typeDocument)
    }
  }, [profile, allTypeDocuments])

  useEffect(() => {
    if (!profile || !profile.classifierCategory || !profile.classifierCategory.companyId || profile.classifierCategory.companyId === NIL || companies.length === 0) return
    let copmany = companies.find(company => company.id === profile.classifierCategory.companyId)
    if (copmany) {
      setCompanyId(copmany.id)
    }
  }, [profile, companies])

  useEffect(() => {
    handleChangeTypeDocument()
  }, [allTypeDocuments, serviceConservationMessage, proofOfLifeChecked, documentProfile.documentProfile, typeDocument])

  const handleChangeTypeDocument = (e) => {
    if (allTypeDocuments.length === 0 || !documentProfile) return
    const profileDocumentsSelected = documentProfile.documentProfile.filter(item => { return item.checked })
    let infoTypeString = ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT

    if (proofOfLifeChecked || serviceConservationMessage || profileDocumentsSelected.length > 0) {
      infoTypeString = ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE
    }

    const typeDocumentsFiltered = allTypeDocuments.filter(td => { return td.infoType === infoTypeString })
    if (typeDocument && typeDocument.infoType && infoTypeString !== typeDocument.infoType) {
      setTypeDocument('')
    }
    setTypeDocuments(typeDocumentsFiltered)
  }

  const deleteSigatureProfiles = () =>
    signatureProfileService.deleteSigatureProfiles(token, id);

  //save icon
  const onSaveImg = () => {
    toggleDialogIcon();
    setuploadImage(image);
  };

  const onChangeUserDocumentProfile = (checked, index) => {
    const copyUser = [...documentProfile.documentProfile]
    copyUser[index] = {
      ...copyUser[index],
      checked,
    }
    setDocumentProfile({ ...documentProfile, documentProfile: copyUser })
  }

  const fetch = async () => {
    let types =
      signatureTypeESign || signatureTypeAdvance || signatureTypeAutograph;
    let ordens =
      processRandom ||
      processSequential ||
      processAprovation ||
      processAprovationSequential;

    let filteredDocument = {};
    filteredDocument.documentProfile = documentProfile.documentProfile.filter(
      (item) => item.checked
    );

    if (name && description && ordens && types && image) {
      setIsLoading(true);
      setShowDialog(true);

      let subCategoryId = selectedSubCategoryId || 0;
      let pathBreadcrumb = "";

      if (subCategoryId && subCategories.length > 0) {
        const breadcrumbParts = [];
        let currentNode = subCategories.find(cat => cat.id === subCategoryId);

        while (currentNode) {
          breadcrumbParts.unshift(currentNode.id);
          if (!currentNode.parentId || currentNode.parentId === 0) break;
          currentNode = subCategories.find(cat => cat.id === currentNode.parentId);
        }

        pathBreadcrumb = breadcrumbParts.join("/");
      }

      let dataClassifier = {
        companyId,
        categoryId,
        subCategoryId,
        pathBreadcrumb,
        typeDocument
      };

      const baseData = {
        name,
        description,
        icon: image,
        numberDaysLimit: days,
        defaultName: requestName,
        defaultComments: comments,
        processRandom,
        processSequential,
        processAprovation,
        processAprovationSequential,
        serviceConservationMessage,
        serviceTimeStamp,
        signatureTypeESign,
        signatureTypeAdvance,
        signatureTypeAutograph,
        documentProfile: filteredDocument,
        proofOfLife: proofOfLifeChecked,
        dataClassifier,
      };

      try {
        if (id) {
          await signatureProfileService
            .changeSigatureProfiles(token, { id, ...baseData })
            .then((res) => {
              if (res.statusCode < 1) throw new Error(res.message);
              setSuccess(true);
              setIsLoading(false);
              setTimeout(() => {
                history.push({ pathname: `/signature-profile` });
              }, 2000);
            });
        } else {
          await signatureProfileService
            .createSigatureProfiles(token, { microserviceId: 2, ...baseData })
            .then((res) => {
              if (res.statusCode < 1) throw new Error(res.message);
              setSuccess(true);
              setIsLoading(false);
              setTimeout(() => {
                history.push({ pathname: `/signature-profile` });
              }, 2000);
            });
        }
      } catch (err) {
        setError(true);
        setTextError(err.message);
        setIsLoading(false);
        toggleDialog();
      }
    } else {
      let messageError = t("signatureProfilesDetailsView.errors.add.image")
      if (!types) messageError = t("signatureProfilesDetailsView.errors.add.type")
      if (!ordens) messageError = t("signatureProfilesDetailsView.errors.add.order")
      if (!description) messageError = t("signatureProfilesDetailsView.errors.add.description")
      if (!name) messageError = t("signatureProfilesDetailsView.errors.add.name")
      setError(true);
      setTextError(messageError);
      setIsLoading(false);
      setTimeout(() => {
        setError(false)
      }, 3000)
    }
  };

  //Delete icon, cancel btn
  const onCancelIcon = () => {
    toggleDialogIcon();
    setImage(null);
    setuploadImage(null);
  };

  const handleChangeAutographCheck = (e) => {
    setsignatureTypeAutograph(e.target.checked)
    if (signatureTypeAutograph) {
      setProofOfLifeChecked(false)
      setBiometricId('')
    }
  }

  const handleChangeBiometric = (e, id) => {
    let proofOfLife = (id === 'proofOfLife') ? true : false
    let biometric = id

    if (biometricId && id && id === biometricId) {
      proofOfLife = false
      biometric = ''
    }

    setProofOfLifeChecked(proofOfLife)
    setBiometricId(biometric)
  }

  const handleSelectPSC = (e, service) => {
    let value = e.target.checked
    let conservationMessage = false
    let timeStamp = false
    let psc = ''

    if (!pscSelected && !value && service === pscSelected) {
      conservationMessage = false
      timeStamp = false
      psc = ''
    } else if (pscSelected && !value && service === pscSelected) {
      conservationMessage = false
      timeStamp = false
      psc = ''
    } else if (!pscSelected && !value && service === t("signatureProfilesDetailsView.messagePreservation")) {
      conservationMessage = true
      psc = t("signatureProfilesDetailsView.messagePreservation")
    } else if (!pscSelected && !value && service === t("signatureProfilesDetailsView.digitalTime")) {
      timeStamp = true
      psc = t("signatureProfilesDetailsView.digitalTime")
    } else if (pscSelected !== service && value && service === t("signatureProfilesDetailsView.messagePreservation")) {
      conservationMessage = true
      psc = t("signatureProfilesDetailsView.messagePreservation")
    } else if (pscSelected !== service && !value && service === t("signatureProfilesDetailsView.messagePreservation")) {
      timeStamp = true
      psc = t("signatureProfilesDetailsView.digitalTime")
    } else if (pscSelected !== service && value && service === t("signatureProfilesDetailsView.digitalTime")) {
      timeStamp = true
      psc = t("signatureProfilesDetailsView.digitalTime")
    } else if (pscSelected !== service && !value && service === t("signatureProfilesDetailsView.digitalTime")) {
      conservationMessage = true
      psc = t("signatureProfilesDetailsView.messagePreservation")
    }

    setserviceConservationMessage(conservationMessage)
    setserviceTimeStamp(timeStamp)
    setPSCSelected(psc)
  }

  const handleChange = (e, setValue, type, setShowError, typeSelect) => {
    let value = e.target.value
    if (type === 'Number') value = Number(value)
    if (setShowError) setShowError(false)
    setValue(value)

    if (typeSelect === 'company') {
      getCategories(value, setCategoryId, setSelect)
    }
  }

  const getCompanies = async () => {
    setIsLoading(true);
    toggleDialog();
    try {
      let companiesBD = await companyService.getUsersCompanies(token)
      if (companiesBD && companiesBD.data && Number(companiesBD.statusCode) === 200) {
        let companies = companiesBD.data.map(item => ({
          ...item,
          ...(item.company || {}),
          id: item?.company?.id,
          companyName: item?.company?.companyName,
        }))
        companies = companies.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()));
        let noAssign = {
          companyName: t("signatureProfilesDetailsView.digitalVault.withoutAssign"),
          id: NIL_UUID
        }
        companies.unshift(noAssign)
        setCompanies(companies)
        // setCategories([{ id: 0, name: 'Sin asignar' }])
        // setSubCategories([{ items: [], subcategory: {} }])
        setIsLoading(false)
        toggleDialog();

      } else {
        setError(true);
        setTextError(t("signatureRequestProfileAction.error.companies"));
        setIsLoading(false);
        toggleDialog();
        setTimeout(() => {
          setError(false);
        }, 4000)
        return false
      }
    } catch (error) {
      setError(true);
      setTextError(t("signatureRequestProfileAction.error.companies"));
      setIsLoading(false);
      toggleDialog();
      setTimeout(() => {
        setError(false);
      }, 4000)
      return false
    }
  }
  const DOCUMENT_TYPE = process.env.REACT_APP_DIGITAL_VAULT_DOCUMENT
  const EXPEDIENTE_TYPE = process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE

  const getTypeDocuments = async () => {
    try {
      let typeDocumentsBD = await categoryService.getTypeDocuments(token, DOCUMENT_TYPE)
      let typeExpedienteBD = await categoryService.getTypeDocuments(token, EXPEDIENTE_TYPE)

      let allTypes = []

      if (typeDocumentsBD && typeDocumentsBD.data && Number(typeDocumentsBD.statusCode) === 200) {
        allTypes = [...allTypes, ...typeDocumentsBD.data]
      }

      if (typeExpedienteBD && typeExpedienteBD.data && Number(typeExpedienteBD.statusCode) === 200) {
        allTypes = [...allTypes, ...typeExpedienteBD.data]
      }

      if (allTypes.length > 0) {
        allTypes.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        setAllTypeDocuments(allTypes)
      } else {
        setError(true);
        setTextError(t("signatureRequestProfileAction.error.typedocuments"));
        setIsLoading(false);
        setTimeout(() => {
          setError(false);
        }, 4000)
        return false
      }
    } catch (error) {
      setError(true);
      setTextError(t("signatureRequestProfileAction.error.typedocuments"));
      setIsLoading(false);
      setTimeout(() => {
        setError(false);
      }, 4000)
      return false
    }
  }


  const getCategories = async (companyId, setCategoryId, setSelect) => {
    if (companyId === NIL_UUID) {
      setCategories([{ id: 0, name: t("signatureProfilesDetailsView.digitalVault.withoutAssign") }])
      setSubCategories([])
      setCategoryId(0)
      setSelect([""])
      return
    }

    setIsLoading(true)

    try {
      let categoriesBD = await categoryService.getAllCategoriesByCompanyId({
        companyId: companyId,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        token: token
      })

      if (categoriesBD && categoriesBD.data && Number(categoriesBD.statusCode) === 200) {
        let categories = categoriesBD.data.fileData || []
        let permissionData = categoriesBD.data.permission || {}
        setSubCategories(categories)
        setPermission(permissionData)
        setCategoryId(0)
        setSelect([""])
        setIsLoading(false)
      } else {
        setError(true);
        setTextError(t("signatureRequestProfileAction.error.categories"));
        setIsLoading(false);
        setTimeout(() => {
          setError(false);
        }, 4000)
        return false
      }
    } catch (error) {
      setError(true);
      setTextError(t("signatureRequestProfileAction.error.categories"));
      setIsLoading(false);
      setTimeout(() => {
        setError(false);
      }, 4000)
      return false
    }
  }

  async function refreshFileManager(refresh = true) {
    try {
      const response = await categoryService.getAllCategoriesByCompanyId({
        companyId,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        token
      }, refresh)

      if (response && response.data && Number(response.statusCode) === 200) {
        const categories = response.data.fileData || []
        const permissionData = response.data.permission || {}
        setSubCategories([...categories])
        setPermission(permissionData)
      }
    } catch (err) {
      console.error('Error refreshing categories:', err)
    }
  }


  const handleAddSubcategory = () => {
    setShowCategoryDialog(true)
  }

  const handleCreateSubcategory = async () => {
    if (!categoryName.trim()) {
      setCategoryNameError(true)
      return
    }
    setCategoryNameError(false)
    setIsLoading(true)

    try {
      // Usar selectedSubCategoryId como padre (el nodo actualmente seleccionado)
      const parentId = selectedSubCategoryId > 0 ? selectedSubCategoryId : null
      const level = 2

      const response = await categoryService.createNewCategory(
        categoryName.trim(),
        null,
        null,
        null,
        'Custom',
        companyId,
        'Sub',
        level,
        parentId,
        false,
        token
      )

      if (response && response.data && response.statusCode === 200) {
        // Refrescar el árbol igual que digital-vault-upload
        await refreshFileManager(true)

        setCategoryName('')
        setShowCategoryDialog(false)
        setSuccess(true)
        setTimeout(() => setSuccess(false), 2000)
      } else {
        throw new Error(response.message || 'Error al crear subcategoría')
      }
    } catch (error) {
      console.error(error)
      setError(true)
      setTextError(error.message)
      setTimeout(() => setError(false), 3000)
    } finally {
      setIsLoading(false)
    }
  }

  const onChangeTree = (event) => {
    const selectedNode = event.nodeData
    if (selectedNode && selectedNode.id) {
      setCategoryId(selectedNode.parentId || 0)
      setSelectedSubCategoryId(selectedNode.id)
    }

    setSelect([event.itemHierarchicalIndex])
    setShowErrorSub(false)
  }



  const getCategoriesAndSelectSubcategory = async (companyId, subCategoryId, pathBreadcrumb) => {
    if (!companyId || companyId === NIL_UUID) return

    setIsLoading(true)
    try {
      const categoriesBD = await categoryService.getAllCategoriesByCompanyId({
        companyId,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        token
      })

      if (categoriesBD && categoriesBD.data && Number(categoriesBD.statusCode) === 200) {
        const categories = categoriesBD.data.fileData || []
        setSubCategories(categories)

        if (subCategoryId && categories.length > 0) {
          const selectedNode = categories.find(cat => cat.id === subCategoryId)
          if (selectedNode) {
            const hierarchicalIndex = buildHierarchicalIndex(categories, subCategoryId)
            const parentIds = getParentIds(categories, subCategoryId)

            setSelectedSubCategoryId(subCategoryId)
            setCategoryId(parentIds[parentIds.length - 1] || 0)

            setExpandedNodes(parentIds.map(id => id.toString()))
            setSelect([hierarchicalIndex])

            setTimeout(() => {
              if (!treeViewRef.current) return;

              try {
                const tree = treeViewRef.current;
                const liElements = tree.element.querySelectorAll('li[data-uid]');
                let targetUid = null;

                liElements.forEach(li => {
                  const nodeData = tree.getNode(li);
                  if (nodeData && nodeData.id && nodeData.id.toString() === subCategoryId.toString()) {
                    targetUid = li.getAttribute('data-uid');
                  }
                });

                if (targetUid) {
                  tree.selectedNodes = [targetUid];
                }

              } catch (err) {
                console.warn('⚠️ No se pudo seleccionar subcategoría automáticamente:', err);
              }
            }, 600);


          }
        } else {
          setSelect([''])
        }
      }
    } catch (err) {
      console.error('Error al cargar categorías:', err)
    } finally {
      setIsLoading(false)
    }
  }


  const buildHierarchicalIndex = (categories, targetId) => {
    const targetNode = categories.find(cat => cat.id === targetId)
    if (!targetNode) return ""

    const path = []
    let currentNode = targetNode

    while (currentNode) {
      const siblings = categories.filter(cat => cat.parentId === currentNode.parentId)
      const index = siblings.findIndex(cat => cat.id === currentNode.id)
      path.unshift(index)

      if (!currentNode.parentId || currentNode.parentId === 0) break
      currentNode = categories.find(cat => cat.id === currentNode.parentId)
    }

    return path.join('_')
  }

  const getParentIds = (categories, targetId) => {
    const parentIds = []
    let currentNode = categories.find(cat => cat.id === targetId)

    while (currentNode && currentNode.parentId && currentNode.parentId !== 0) {
      parentIds.push(currentNode.parentId)
      currentNode = categories.find(cat => cat.id === currentNode.parentId)
    }

    return parentIds
  }

  const findNodeByHierarchicalIndex = (categories, hierarchicalIndex) => {
    if (!hierarchicalIndex || hierarchicalIndex === '') return null

    const indices = hierarchicalIndex.split('_').map(idx => parseInt(idx))
    let currentLevel = categories.filter(cat => !cat.parentId || cat.parentId === 0)
    let selectedNode = null

    for (let i = 0; i < indices.length; i++) {
      const index = indices[i]
      if (index >= 0 && index < currentLevel.length) {
        selectedNode = currentLevel[index]

        if (i < indices.length - 1) {
          currentLevel = categories.filter(cat => cat.parentId === selectedNode.id)
        }
      } else {
        return null
      }
    }

    return selectedNode
  }


  useEffect(() => {
    if (!profile || !profile.classifierCategory || companies.length === 0) return;

    const { companyId, categoryId, subCategoryId, pathBreadcrumb } = profile.classifierCategory;

    if (companyId && companyId !== NIL_UUID) {
      setCompanyId(companyId);
      setCategoryId(categoryId || 0);
      setSelectedSubCategoryId(subCategoryId || 0);
      getCategoriesAndSelectSubcategory(companyId, subCategoryId, pathBreadcrumb);
    }
  }, [profile, companies]);


  return (
    <div className='standard-wrapper'>
      <div className="signatureProfileDetailView-container">
        <div className="signatureProfileDetailView-header">
          <HeaderHLPure title={t(id ? "signatureProfilesDetailsView.titleEdite" : "signatureProfilesDetailsView.titleCreate")} />
        </div>
        <div className="signatureProfileDetailView-body">
          <div className="signatureProfileDetailView-elements">
            {/* Data profile */}
            <InputHLPure
              inputActive
              labelInput={t("signatureProfilesDetailsView.name")}
              typeInput={"text"}
              valueInput={name}
              handleChangeInput={(e) => setName(e.target.value)}
              required
              tooltipShow
              informationIcon
              positionTooltip={isMobile ? "top" : "right"}
              titleTooltip={t(
                "signatureProfilesDetailsView.name"
              )}
              descriptionTooltip={t(
                "signatureProfilesDetailsView.nameTooltip"
              )}
            />
            <TextAreaHLPure
              labelTextArea={t(
                "signatureProfilesDetailsView.desription"
              )}
              valueTextData={description}
              handleChangeTextArea={(e) =>
                setDescription(e.target.value)
              }
              required
              tooltipShow
              informationIcon
              positionTooltip={isMobile ? "top" : "right"}
              titleTooltip={t(
                "signatureProfilesDetailsView.desription"
              )}
              descriptionTooltip={t(
                "signatureProfilesDetailsView.desriptionTooltip"
              )}
            />
            <div className="signatureProfileDetailView-grid-elements">
              <InputHLPure
                inputActive
                labelInput={t(
                  "signatureProfilesDetailsView.nameRequest"
                )}
                typeInput={"text"}
                valueInput={requestName}
                handleChangeInput={(e) =>
                  setRequestName(e.target.value)
                }
                tooltipShow
                informationIcon
                positionTooltip={isMobile ? "top" : "right"}
                titleTooltip={t(
                  "signatureProfilesDetailsView.nameRequest"
                )}
                descriptionTooltip={t(
                  "signatureProfilesDetailsView.nameRequestTooltip"
                )}
              />
              {isMobile ?
                <TextAreaHLPure
                  labelTextArea={t(
                    "signatureProfilesDetailsView.commet"
                  )}
                  valueTextData={comments}
                  handleChangeTextArea={(e) =>
                    setComments(e.target.value)
                  }
                  characterLimit={250}
                  tooltipShow
                  informationIcon
                  positionTooltip={isMobile ? "top" : "right"}
                  titleTooltip={t(
                    "signatureProfilesDetailsView.commet"
                  )}
                  descriptionTooltip={t(
                    "signatureProfilesDetailsView.commetTooltip"
                  )}
                />
                :
                <InputHLPure
                  inputActive
                  labelInput={t("signatureProfilesDetailsView.days")}
                  typeInput={"number"}
                  valueInput={days}
                  placeholder={"1"}
                  max={60}
                  min={1}
                  handleChangeInput={(e) =>
                    setDays(parseInt(e.target.value) || 0)
                  }
                  onBlur={(e) => {
                    const val = e.target.value;
                    if (val.trim() == "" || +val < 1) setDays(1);
                    if (+val > 60) setDays(60);
                  }}
                  tooltipShow
                  informationIcon
                  positionTooltip={isMobile ? "top" : "right"}
                  titleTooltip={t(
                    "signatureProfilesDetailsView.days"
                  )}
                  descriptionTooltip={t(
                    "signatureProfilesDetailsView.daysTooltip"
                  )}
                />

              }

              {!isMobile ?
                <TextAreaHLPure
                  labelTextArea={t(
                    "signatureProfilesDetailsView.commet"
                  )}
                  valueTextData={comments}
                  handleChangeTextArea={(e) =>
                    setComments(e.target.value)
                  }
                  characterLimit={250}
                  tooltipShow
                  informationIcon
                  positionTooltip={isMobile ? "top" : "right"}
                  titleTooltip={t(
                    "signatureProfilesDetailsView.commet"
                  )}
                  descriptionTooltip={t(
                    "signatureProfilesDetailsView.commetTooltip"
                  )}
                />
                :
                <InputHLPure
                  inputActive
                  labelInput={t("signatureProfilesDetailsView.days")}
                  typeInput={"number"}
                  valueInput={days}
                  placeholder={"1"}
                  max={60}
                  min={1}
                  handleChangeInput={(e) =>
                    setDays(parseInt(e.target.value) || 0)
                  }
                  onBlur={(e) => {
                    const val = e.target.value;
                    if (val.trim() == "" || +val < 1) setDays(1);
                    if (+val > 60) setDays(60);
                  }}
                  tooltipShow
                  informationIcon
                  positionTooltip={isMobile ? "top" : "right"}
                  titleTooltip={t(
                    "signatureProfilesDetailsView.days"
                  )}
                  descriptionTooltip={t(
                    "signatureProfilesDetailsView.daysTooltip"
                  )}
                />
              }
              <div>
                <DividerSubtitle
                  subtitle={t("signatureProfilesDetailsView.image")}
                  tooltipText={t("signatureProfilesDetailsView.image.tooltip")}
                  positionTooltip={isMobile ? "top" : "right"}
                />
                <button
                  className={`signatureProfilesDetails-rec rec-1 ${true && "disable-cursor"
                    }`}
                  onClick={toggleDialogIcon}
                >
                  {!image && <img src={PlusBlue} width={55} />}
                  {image && (
                    <img
                      className={`siganture-profile-img`}
                      src={image}
                    />
                  )}
                </button>
              </div>
            </div>
            <hr />
            {/* Services PSC */}
            <div>
              <DividerSubtitle
                subtitle={t(
                  "signatureProfilesDetailsView.serviciosTitle"
                )}
                tooltipText={t(
                  "signatureProfilesDetailsView.serviciosTitleTooltip"
                )}
                positionTooltip={isMobile ? "top" : "right"}
              />
              <div className="signatureProfileDetailView-checks">
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.messagePreservation"
                  )}
                  checkedState={serviceConservationMessage}
                  onChangeHandler={(e) =>
                    handleSelectPSC(e, t("signatureProfilesDetailsView.messagePreservation"))
                  }
                />
              </div>
            </div>
            {/* Signature Type */}
            <div>
              <DividerSubtitle
                subtitle={`${t(
                  "signatureProfilesDetailsView.typeTitle"
                )} *`}
                tooltipText={t(
                  "signatureProfilesDetailsView.typeTitleTooltip"
                )}
                positionTooltip={isMobile ? "top" : "right"}
              />
              <div className="signatureProfileDetailView-checks">
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.e.signature"
                  )}
                  checkedState={signatureTypeESign}
                  onChangeHandler={(e) =>
                    setsignatureTypeESign(e.target.checked)
                  }
                />
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.electronicSignature"
                  )}
                  checkedState={signatureTypeAdvance}
                  onChangeHandler={(e) =>
                    setsignatureTypeAdvance(e.target.checked)
                  }
                />
                <div className="signatureProfilesDetails-govoauth">
                  <CheckBoxHLPure
                    labelCheckBox={t(
                      "signatureProfilesDetailsView.autograph"
                    )}
                    checkedState={signatureTypeAutograph}
                    onChangeHandler={(e) => handleChangeAutographCheck(e)}
                  />
                  {
                    signatureTypeAutograph && (
                      <div className="signatureProfileDetailView-proofOflife">
                        <CheckBoxHLPure
                          labelCheckBox={t("signatureProfilesView.biometric.validation")}
                          checkedState={proofOfLifeChecked}
                          onChangeHandler={(e) => handleChangeBiometric(e, "proofOfLife")}
                        />
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
            {/* Order */}
            <div>
              <DividerSubtitle
                subtitle={`${t(
                  "signatureProfilesDetailsView.orderTitle"
                )} *`}
                tooltipText={t(
                  "signatureProfilesDetailsView.orderTitleTooltip"
                )}
                positionTooltip={isMobile ? "top" : "right"}
              />
              <div className="signatureProfileDetailView-checks">
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.random"
                  )}
                  checkedState={processRandom}
                  onChangeHandler={(e) =>
                    setprocessRandom(e.target.checked)
                  }
                />
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.sequential"
                  )}
                  checkedState={processSequential}
                  onChangeHandler={(e) =>
                    setprocessSequential(e.target.checked)
                  }
                />
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.approvingly"
                  )}
                  checkedState={processAprovation}
                  onChangeHandler={(e) =>
                    setprocessAprovation(e.target.checked)
                  }
                />
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.approval"
                  )}
                  checkedState={processAprovationSequential}
                  onChangeHandler={(e) =>
                    setprocessAprovationSequential(e.target.checked)
                  }
                />
              </div>
            </div>
            <hr />
            {/* Document profiles */}
            <div>
              <DividerSubtitle
                subtitle={t("signatureProfilesDetailsView.document.profile")}
                tooltipText={t(
                  "signatureProfilesDetailsView.typeTitleTooltip"
                )}
                positionTooltip={isMobile ? "top" : "right"}
              />
              <div className="signatureProfileDetailView-checks-document-profile">
                {documentProfile.documentProfile.length > 0 &&
                  documentProfile.documentProfile.map(
                    (item, index) => (
                      <CheckBoxHLPure
                        labelCheckBox={item.documentName}
                        checkedState={item.checked}
                        onChangeHandler={(e) =>
                          onChangeUserDocumentProfile(
                            e.target.checked,
                            index
                          )
                        }
                      />
                    )
                  )}
              </div>
            </div>
            <hr />
            {/* Assign categories */}
            <div className="signatureProfilesDetails-container-assign-categories">
              <div className="signatureRequestCategoriesView-subtitle">
                <p className="signatureRequestCategoriesView-label-title">{t("assign.categories.title")}</p>
              </div>

              <ClassificationPanelPure
                companies={companies}
                companyId={companyId}
                onCompanyChange={(e) =>
                  handleChange(e, setCompanyId, null, setShowErrorCompany, "company")
                }
                showCompanyError={showErrorCompany}
                companyErrorMessage={t("questionnairesAssignCategories.company.error")}
                categoriesData={subCategories}
                categoryId={selectedSubCategoryId}
                onTreeNodeClick={(e) => onChangeTree(e)}
                treeRefCallback={(ref) => {
                  treeViewRef.current = ref
                }}
                expandedNodes={expandedNodes}
                onAddSubcategory={handleAddSubcategory}
                showAddSubcategoryButton={true}
                canCreateSubcategory={canCreateSubcategory}
                usePanelBar={true}
                selectedNodes={selectedSubCategoryId ? [selectedSubCategoryId.toString()] : []}
                showCategoryDialog={showCategoryDialog}
                onCloseCategoryDialog={() => setShowCategoryDialog(false)}
                onSubmitCategory={handleCreateSubcategory}
                categoryName={categoryName}
                onCategoryNameChange={setCategoryName}
                categoryNameError={categoryNameError}
                dialogType="subcategory"

                typeDocuments={typeDocuments}
                selectedTypeDocument={typeDocument}
                onTypeDocumentChange={(e) =>
                  handleChange(e, setTypeDocument, null, setShowTypeDoc)
                }
                showTypeDocError={showErrorTypeDoc}
                typeDocErrorMessage={t("questionnairesAssignCategories.error.type.document")}
                infoType={currentInfoType}
              />
            </div>
            <div className="signatureProfilesDetails-btn-container">
              <ButtonHLPure
                nameBtn={t("signatureProfilesDetailsView.back")}
                onClickBtn={() => history.push("/signature-profile")}
              />
              {
                showBtnSave && (
                  <ButtonHLPure
                    primary
                    nameBtn={t("signatureProfilesDetailsView.save")}
                    onClickBtn={fetch}
                  />
                )
              }
            </div>
          </div>
        </div>
        <div className="signatureProfileDetailView-footer">
          <PromotionalFooterPure />
        </div>
        {showDialogIcon && (
          <DialogTemplatePure
            cancel={onCancelIcon}
            title={t("signatureProfilesDetailsView.modal.title")}
            description={t("signatureProfilesDetailsView.modal.instructions")}
            canelBtn={t("button.cancel")}
            saveBtn={t("button.save")}
            handleSubmitProfile={(event) => onSaveImg(event)}
            loadingComponent={isLoading}
          >
            <div
              className="signatureProfilesDetailsView-container-gallery"
              xs={12}
            >
              {icons.map((item, index) => (
                <div className="signatureProfilesDetailsView-container-icons">
                  <RadioButton
                    className="signatureProfilesDetailsView-radioBtn-img"
                    name="icon"
                    value={item.path}
                    checked={image === item.path}
                    onChange={({ value }) => setImage(value)}
                  />
                  <img
                    src={item.path}
                    {...item}
                    className="icon-style"
                    key={index}
                  />
                </div>
              ))}
            </div>
          </DialogTemplatePure>
        )}

        {showDialog && (
          <DialogSystemGLPure
            showLoadingRequesting={isLoading}
            toggleLoadingRequesting={() => setIsLoading((prev) => !prev)}
            showCompletedRequesting={success}
            toggleCompletedRequesting={() => setSuccess((prev) => !prev)}
            showErrorRequesting={error}
            toggleErrorRequesting={() => setError((prev) => !prev)}
            messageError={textError}
          />
        )}
      </div>
    </div >
  );
}
